import omit from 'lodash/fp/omit'
import type { Theme } from '@mui/material'
import type { SystemStyleObject } from '@mui/system'

type BorderSide = 'borderTop' | 'borderRight' | 'borderBottom' | 'borderLeft'

/**
 * `sx` drawing a divider-coloured border on only the named sides.
 *
 * Every side starts at `border: 1` and is then zeroed, so naming a side is what
 * leaves its width standing.
 *
 * These are MUI **system** values, which `Box` accepted as props until v9 removed
 * them. Handed over as props today they style nothing and reach the DOM as invalid
 * attributes instead, so this returns `sx` and callers merge it:
 * `sx={[borderSx(['borderBottom']), { p: 2 }]}`.
 */
export const borderSx = (sides: BorderSide[]): SystemStyleObject<Theme> =>
  omit(sides, {
    border: 1,
    borderBottom: 0,
    borderRight: 0,
    borderLeft: 0,
    borderTop: 0,
    borderColor: 'divider',
  })
